import styled from "styled-components";
const TabPanelImpl = styled("div").attrs({
  role: "tabpanel"
})({
  display: "flex",
  flexDirection: "column",
  flex: "1 0 auto",
  outline: "none",
  "&[hidden]": {
    display: "none"
  }
});
export {
  TabPanelImpl
};
